import React from "react";
import { logoutHandler } from "./logoutHelper";
import { EXCEL_FILE_OUTLET_COMPLIANCE_CHECK_UPDATE_BASE64, R20_EXCEL_FILE_OUTLET_COMPLIANCE_CHECK_UPDATE_BASE64 } from "../constants/config-constants";
import { components } from "react-select";
import { isShadowUser } from "./effectiveEmailHelper";

export const getLevelUserName = (parentLevel, userDetails) => {
  if (parentLevel?.name) return parentLevel.name;
  const parentEmail = String(userDetails?.parentEmail ?? "").trim();
  if (isShadowUser(userDetails) && parentEmail) {
    return userDetails?.parentEmailName || "";
  }
  return userDetails?.name || "";
};

export const getApiParam = (selectedValue) => {
  return selectedValue === "day" ? "Intraday" : selectedValue;
};

export const getMainNameTeam = (parentLevel, role, location, mainTeamName) => {
  return parentLevel?.level !== role && location ? mainTeamName : "";
};

export const renderAchievement = (achPercent, isPercentSwapped, achValue) => {
  if (
    achPercent === null ||
    achPercent === "Infinity" ||
    achPercent === Infinity
  ) {
    return "(NA)";
  }
  return <span>{isPercentSwapped ? achValue : (achPercent || "0") + "%"}</span>;
};

export const renderAchPercent = (achPercent) => {
  if (achPercent === null || achPercent === "Infinity") {
    return "(NA)";
  }
  return <span>{achPercent || "0"}%</span>;
};

// filterHelpers.js
export function updateFilterValue(fil, name, value) {
  if (value !== "") {
    if (Array.isArray(fil[name]) && fil[name]?.length > 0) {
      if (fil[name].includes(value)) {
        if (fil[name]?.length > 1) {
          fil[name] = fil[name].filter((f) => f !== value);
        } else {
          fil[name] = "";
        }
      } else {
        fil[name] = [...fil[name], value];
      }
    } else {
      fil[name] = [value];
    }
  } else {
    fil[name] = value;
  }
}


export const achievementValue  = (strikeRateAch, strikeRateTotalStores) => {
  return strikeRateAch && strikeRateTotalStores ?
    <span>{Math.round(strikeRateAch / strikeRateTotalStores * 100 * 10) / 10}%</span> : "(NA)";
};


export const getIsPasswordExpiring = (passExpirationDays, userDetails, history) => {
  const ssoUser = localStorage.getItem("loginType") === "NON_SSO";
  const countryCode = localStorage.getItem("countryCode");
  if (passExpirationDays && passExpirationDays <= 0) {
    logoutHandler(countryCode, userDetails, history);
  } else {
    return passExpirationDays && passExpirationDays <= 30 && ssoUser;
  }
}

export const getUpdatedLevelArray = (level, levelName) => {
  let indexState = null;
  const updateArray = level.map((item, index) => {
    if (index > 0 && levelName === item.levelname) {
      indexState = index;
      return { ...item, active: false };
    }
    return item;
  });
  return { updateArray, indexState };
};

export const activatePreviousLevel = (updateArray, indexState) => {
  let previousLevel = updateArray[indexState - 1];
  previousLevel = { ...previousLevel, active: true };
  updateArray[indexState - 1] = previousLevel;
};

export const onLevelsBack = ({
  GaEventHelper,
  userDetails,
  history,
  isDisciplinary,
  isDistributor,
  getEventType,
  level,
  getUpdatedLevelArray,
  levelName,
  activatePreviousLevel,
  navigateToHome,
  updateLevel,
}) => {
  GaEventHelper.gaCommonEvent({
    userDetails: userDetails,
    screen_name: history?.location?.pathname?.replace("/", ""),
    event: getEventType(isDisciplinary, isDistributor),
  });
  if (level?.length > 0) {
    let { updateArray, indexState } = getUpdatedLevelArray(level, levelName);
    if (indexState > 1) {
      activatePreviousLevel(updateArray, indexState);
    } else {
      navigateToHome();
    }
    updateLevel(updateArray);
  }
};

export const filterRowDataBySearch = (rowData, text) => {
  if (!rowData || !text) return rowData;
  if (text.length > 2) {
    const search = text.toLowerCase();
    return rowData.filter((item) => {
      const name = item?.user?.name?.toLowerCase() || "";
      const email = item?.user?.email?.toLowerCase() || "";
      return name.includes(search) || email.includes(search);
    });
  }
  return rowData;
};

export const handleCheckbox = (event, filterValue, handleValueChange) => {
  if (event.target.checked) {
    handleValueChange([...filterValue, event.target.name]);
  } else {
    const value = filterValue.filter((item) => item !== event.target.name);
    handleValueChange(value);
  }
};

const GEO_FIELDS = [
  "geoCodeX",
  "geoCodeY",
  "endVisitGeoCodeX",
  "endVisitGeoCodeY"
];

const truncateDecimal = (value, decimals = 7) => {
  const num = Number(value);
  if (isNaN(num)) return value;

  const factor = Math.pow(10, decimals);
  return Math.trunc(num * factor) / factor;
};

export const formatGeoFields = (record, countryCode) => {
  GEO_FIELDS.forEach((field) => {
    if (record[field] !== undefined && record[field] !== null) {
      record[field] =
        countryCode === "bd"
          ? truncateDecimal(record[field], 7)
          : record[field];
    }
  });

  return record;
};

export const applyGeoFormatting = (reportName, data, countryCode) => {
  if (reportName !== "Salesperson Visit Summary") return data;

  return data.map((item) => formatGeoFields(item, countryCode));
};

export const buildOptionsFromFilters = (filters) => ({
  salesmanCode: filters?.salesmanCode?.map(code => ({ label: code, value: code })) || [],
  phoneNumber: filters?.phoneNumber?.map(code => ({ label: code, value: code })) || [],
});

export const getPlaceholderTextHelper = (searchType, t) => {
  return searchType === "salesmanCode"
    ? t("SMCode_Placeholder")
    : t("Phone_Number_Placeholder");
};

  const isValidDDMMYYYY = (dateStr) => {
    const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/

    if(!regex.test(dateStr)) return false;

    const [dd, mm, yyyy] = dateStr.split("/").map(Number);
    const date = new Date(yyyy, mm -1, dd);

    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    )
  }

  export const getDownloadOptions = (isR20Disable) => {
    return isR20Disable ? EXCEL_FILE_OUTLET_COMPLIANCE_CHECK_UPDATE_BASE64 : R20_EXCEL_FILE_OUTLET_COMPLIANCE_CHECK_UPDATE_BASE64;
  }

  export const validateStartDateRange = ({ row, setFileError, resolve }) => {
    const start = row["Start Date"];
    if (!start) return false;

    if(!isValidDDMMYYYY(start)) {
      setFileError({
        header: "INVALID START DATE FORMAT",
        message: `Start Date in Row ${row.__rowNum__ + 1} must be in DD/MM/YYYY format`
      })
      resolve("invalid");
      return true;
    }

    const [dd, mm, yyyy] = start.split("/").map(Number);
    const startDate = new Date(yyyy, mm-1, dd);
    startDate.setHours(0, 0, 0, 0);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // today + 30 days
    const maxAllowed = new Date();
    maxAllowed.setDate(maxAllowed.getDate() + 29);
    maxAllowed.setHours(0, 0, 0, 0);

    if (startDate < today || startDate > maxAllowed) {
      setFileError({
        header: "INVALID START DATE",
        message: `Start date in Row ${row.__rowNum__ + 1} falls in invalid period`
      });
      resolve("invalid");
      return true;
    }

    return false;
  };

  export const getMaxEndDateFromStart = (startDate) => {
    if (!startDate) return null;

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const startDay = start.getDate();

    const nextMonth = new Date(start);
    nextMonth.setDate(1);
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    const lastDayOfNextMonth = new Date(
      nextMonth.getFullYear(),
      nextMonth.getMonth() + 1,
      0
    );

    if (startDay <= lastDayOfNextMonth.getDate()) {
      return new Date(
        nextMonth.getFullYear(),
        nextMonth.getMonth(),
        startDay - 1
      );
    }

    return lastDayOfNextMonth;
  };


  export const validateEndDateRange = ({ row, setFileError, resolve }) => {
    const start = row["Start Date"];
    const end = row["End Date"];

    if (!start || !end) return false;

    if(!isValidDDMMYYYY(end)) {
      setFileError({
        header: "INVALID END DATE FORMAT",
        message: `End Date in Row ${row.__rowNum__ + 1} must be in DD/MM/YYYY format`
      })
      resolve("invalid");
      return true;
    }

    const [ddS, mmS, yyyyS] = start.split("/").map(Number)
    const [ddE, mmE, yyyyE] = end.split("/").map(Number)

    const startDate = new Date(yyyyS, mmS -1, ddS);
    const endDate = new Date(yyyyE, mmE -1, ddE);

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (endDate < startDate) {
      setFileError({
        header: "INVALID END DATE",
        message: `End date in Row ${row.__rowNum__ + 1} falls in invalid period`,
      });
      resolve("invalid");
      return true;
    }

    const maxEndDate = getMaxEndDateFromStart(startDate);

    if (endDate > maxEndDate) {
      setFileError({
        header: "INVALID END DATE",
        message: `End date in Row ${row.__rowNum__ + 1} falls in invalid period`,
      });
      resolve("invalid");
      return true;
    }

    return false;
  };

  export const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "2px 4px",
        }}
      >
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => {}}
          style={{
            width: "16px",
            height: "16px",
            cursor: "pointer",
          }}
        />
        <span>{props.label}</span>
      </div>
    </components.Option>
  );
};

export const asyncSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    borderColor: "#D2D6DB",
    boxShadow: "none",
    "&:hover": { borderColor: "#A8AEB8" },
  }),

  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),

  option: (base, state) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    padding: "4px 8px",
    backgroundColor: state.isSelected
      ? "#E6F0FF"
      : state.isFocused
      ? "#F4F7FB"
      : "white",
    color: "#111827",
    cursor: "pointer",
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E6F0FF",
    borderRadius: "4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#374151",
    fontSize: "13px",
  }),

  multiValueRemove: (base) => ({
    ...base,
    cursor: "pointer",
    ":hover": { backgroundColor: "#DFE8F7", color: "black" },
  }),
};
